module.exports = __webpack_public_path__ + "static/007216-e4012fa7c6fca2d11f81dab98e250bd5.jpg";